import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FooterComponent } from './footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import {TranslateModule} from "@ngx-translate/core";

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,

        MatIconModule,
        TranslateModule
    ],
  declarations: [FooterComponent],
  exports: [FooterComponent]
})
export class FooterModule {
}
